<template>
    <div>
        <loading :show="loading"></loading>
        <div class="text-right py-2">
            <a
                href="#"
                class="btn btn-primary btn-lg text-white"
                @click="showNewProductModal()"
                >Add new product</a
            >
        </div>
        <table class="table table-borderless">
            <tbody>
                <tr>
                    <th style="width:15%">Thumbnail</th>
                    <th style="width:25%">Name</th>
                    <th style="width:10%">Price</th>
                    <th style="width:15%">Status</th>
                    <th style="width:35%">Actions</th>
                </tr>

                <template
                    v-if="
                        products.current_page == 1 && products.data.length == 0
                    "
                >
                    <tr>
                        <td colspan="5" style="height:300px">
                            <span class="h4"
                                >No products yet.
                                <a
                                    href="#"
                                    class="btn btn-light"
                                    @click="showNewProductModal()"
                                    >Add new product</a
                                ></span
                            >
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="product in products.data" :key="product.id">
                        <td class="product-image">
                            <img :src="product.thumb" />
                        </td>
                        <td>{{ product.name }}</td>
                        <td>{{ product.price }}</td>
                        <td>
                            <span
                                class="product-status"
                                :class="{
                                    unpublished: product.status == 0,
                                    published: product.status == 1
                                }"
                            >
                                {{ product.status_text }}
                            </span>
                        </td>
                        <td class="product-actions">
                            <a
                                class="btn btn-outline-secondary"
                                href="#"
                                @click="editProduct(product)"
                                >Edit</a
                            >
                            <a
                                class="btn btn-outline-danger"
                                @click="deleteProduct(product)"
                                href="#"
                                >Delete</a
                            >
                            <a
                                class="btn btn-outline-success"
                                @click="togglePublish(product)"
                                href="#"
                            >
                                <span v-if="product.status == 0">
                                    Publish
                                </span>
                                <span v-else>
                                    Unpublish
                                </span>
                            </a>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <pagination :data="products" @pagination-change-page="getProducts">
            <span slot="prev-nav">&lt; Previous</span>
            <span slot="next-nav">Next &gt;</span>
        </pagination>
        <modal
            name="newProductModal"
            @before-close="beforeClose('newProductModal')"
            classes="whatswhat-modal new-product-modal"
            width="60%"
            height="auto"
            :shiftY="0.3"
        >
            <div class="new-product-modal-wrapper">
                <div class="close-modal" @click="closeModal('newProductModal')">
                    <i class="icon-cross"></i>
                </div>
                <h2>Add new product</h2>
                <hr />
                <div id="add-product-wrapper" class="d-flex">
                    <div class="detailedstep">
                        <p class="detailedstep__title mt-3 mb-1">
                            Product title
                        </p>
                        <div class="detailedstep__input">
                            <input
                                type="text"
                                name="title"
                                v-model="$v.newProduct.name.$model"
                                placeholder="Product title"
                                class="input__text"
                                :class="{
                                    'input__text--error':
                                        $v.newProduct.name.$error
                                }"
                            />
                            <span
                                class="detailedstep__error text-left ml-0"
                                v-if="
                                    $v.newProduct.name.$error &&
                                        !$v.newProduct.name.required
                                "
                                >Product name is required</span
                            >
                            <span class="detailedstep__valid" v-else
                                >Field ok</span
                            >
                        </div>

                        <p class="detailedstep__title mt-3 mb-1">
                            Product description
                        </p>
                        <div class="detailedstep__input">
                            <textarea
                                name="product_description"
                                v-model="$v.newProduct.description.$model"
                                id="product-description"
                                cols="30"
                                rows="6"
                                placeholder="Product description"
                                class="input__text"
                                :class="{
                                    'input__text--error':
                                        $v.newProduct.description.$error
                                }"
                            ></textarea>
                            <span
                                class="detailedstep__error text-left ml-0"
                                v-if="
                                    $v.newProduct.name.$error &&
                                        !$v.newProduct.name.required
                                "
                                >Product description is required</span
                            >
                            <span class="detailedstep__valid" v-else
                                >Field ok</span
                            >
                        </div>

                        <p class="detailedstep__title mb-1 mt-3">
                            Product price
                        </p>
                        <div class="detailedstep__input">
                            <input
                                type="text"
                                name="price"
                                v-model="newProduct.price"
                                placeholder="Product price(EUR)"
                                class="input__text"
                                :class="{
                                    'input__text--error':
                                        $v.newProduct.price.$error
                                }"
                            />

                            <span
                                class="detailedstep__error"
                                v-if="
                                    $v.newProduct.price.$error &&
                                        !$v.newProduct.price.isEmptyOrNumber
                                "
                                >Please enter a valid product price</span
                            >
                            <span class="detailedstep__valid" v-else
                                >Field ok</span
                            >
                        </div>
                        <div v-if="displayPayButton">
                            <div class="detailedstep__input">
                                <p class="detailedstep__title mb-1 mt-3">
                                    Product Url
                                </p>
                                <div class="detailedstep__input">
                                    <input
                                        type="text"
                                        name="product_url"
                                        v-model="newProduct.product_url"
                                        placeholder="Product URL"
                                        class="input__text"
                                    />
                                </div>
                            </div>

                            <div class="detailedstep__input">
                                <p class="detailedstep__title mb-1 mt-3">
                                    Product Button Edit
                                </p>
                                <!-- Button to open inner small modal -->
                                <button @click="showEditButtonModal(newProduct)" class="btn btn-outline-secondary">Edit Business Buy Button</button>
                            </div>
                        </div>
                    </div>
                    <div class="detailedstep">
                        <p class="detailedstep__title mt-3 mb-1">
                            Product photos
                        </p>
                        <vue-dropzone
                            ref="myVueDropzone"
                            id="dropzone"
                            :options="dropzoneOptions"
                            @vdropzone-success-multiple="dropzoneCompleted"
                            @vdropzone-mounted="addImages"
                            v-on:vdropzone-removed-file="removeThisFile"
                        ></vue-dropzone>
                    </div>
                </div>
            </div>
            <div class="modal-footer text-right">
                <hr class="my-4" />
                <a
                    href="#"
                    @click="submitProduct()"
                    class="btn btn-primary btn-lg text-white"
                >
                    {{ newProduct.type == "create" ? "Save" : "Update" }}
                    Product
                </a>
                <a
                    @click="closeModal('newProductModal')"
                    class="btn btn-danger btn-lg text-white"
                >
                    Cancel
                </a>
            </div>
        </modal>

        <modal
            id="editButtonModal"
            name="editButtonModal"
            title="Edit Business Buy Button"
            @before-close="beforeClose('editButtonModal')"
            classes="whatswhat-modal new-product-modal"
            size="md"
            width="60%"
            height="auto"
            :shiftY="0.3"
        >
            <div class="new-product-modal-wrapper">
                <div class="close-modal" @click="closeModal('editButtonModal')">
                    <i class="icon-cross"></i>
                </div>
                <div id="add-product-wrapper" class="d-flex">
                    <div class="detailedstep">

                        <p class="detailedstep__title mt-3 mb-1">
                            Button Length:
                        </p>
                        <div class="detailedstep__input">
                            <input type="number" class="input__text" id="buttonLength" v-model="buttonConfig.length" min="100" max="155">
                        </div>

                        <p class="detailedstep__title mt-3 mb-1">
                            Button Height:
                        </p>
                        <div class="detailedstep__input">
                            <input type="number" class="input__text" id="buttonHeight" v-model="buttonConfig.height" min="35" max="55">
                        </div>

                        <p class="detailedstep__title mt-3 mb-1">
                            Background Color:
                        </p>
                        <div class="detailedstep__input">
                            <input type="color" class="" id="backgroundColor" v-model="buttonConfig.backgroundColor">
                        </div>

                        <p class="detailedstep__title mt-3 mb-1">
                            Border Color:
                        </p>
                        <div class="detailedstep__input">
                            <input type="color" class="" id="borderColor" v-model="buttonConfig.borderColor">
                        </div>

                        <p class="detailedstep__title mt-3 mb-1">
                            Border Thickness:
                        </p>
                        <div class="detailedstep__input">
                            <select class="input__text" id="borderThickness" v-model="buttonConfig.borderThickness">
                                <option value="small">Small</option>
                                <option value="medium">Medium</option>
                                <option value="hard">Hard</option>
                            </select>
                        </div>

                        <p class="detailedstep__title mt-3 mb-1">
                            Button Text Color:
                        </p>
                        <div class="detailedstep__input">
                            <input type="color" class="" id="buttonTextColor" v-model="buttonConfig.buttonTextColor">
                        </div>

                        <p class="detailedstep__title mt-3 mb-1">
                            Button Text:
                        </p>
                        <div class="detailedstep__input">
                            <input type="text" class="input__text" id="buttonText" v-model="buttonConfig.buttonText">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer text-right">
                <button @click="updateButtonConfig" class="btn btn-primary">Save</button>
                <button @click="closeModal('editButtonModal')" class="btn btn-danger">Cancel</button>
            </div>
        </modal>
    </div>
</template>

<script>
import Loading from "../Loading.vue";
import vue2Dropzone from "vue2-dropzone";
import { required, decimal, helpers } from "vuelidate/lib/validators";

import "vue2-dropzone/dist/vue2Dropzone.min.css";

const isEmptyOrNumber = value => !helpers.req(value) || !isNaN(value);
export default {
    props: ["business"],
    components: {
        loading: Loading,
        vueDropzone: vue2Dropzone
    },

    data() {
        return {
            loading: false,
            dropzoneOptions: {
                url: "/post",
                autoProcessQueue: false,
                thumbnailWidth: 100,
                uploadMultiple: true,
                thumbnailHeight: 100,
                maxFilesize: 2,
                maxFiles: 10,
                parallelUploads: 10,
                dictDefaultMessage: 'Drop images here to upload (max. 2MB / image)',
                addRemoveLinks: true,
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector(
                        "[name=csrf-token]"
                    ).content
                }
            },
            products: {},
            newProduct: {
                name: "",
                description: "",
                price: "",
                type: "create",
                images: [],
                product_url: "",
                div_config: ""
            },
            buttonConfig: {
                length: 100,
                height: 35,
                backgroundColor: '#ffffff',
                borderColor: '#000000',
                borderThickness: 'small',
                buttonTextColor: '#000000',
                buttonText: ''
            },
            displayPayButton: false
        };
    },

    validations: {
        newProduct: {
            name: {
                required
            },
            description: {
                required
            },
            price: {
                isEmptyOrNumber
            }
        }
    },
    methods: {
        showEditButtonModal(newProduct) {
            console.log('Values edit button modal: ', newProduct);
            console.log('has buttonConfig value? ', !newProduct.div_config);
            if (!newProduct.div_config) {
                this.buttonConfig = {
                    length: 100,
                    height: 35,
                    backgroundColor: '#ffffff',
                    borderColor: '#000000',
                    borderThickness: 'small',
                    buttonTextColor: '#000000',
                    buttonText: ''
                    // alignment: 'middle'
                };
            } else {
                try {
                    console.log(JSON.parse(newProduct.div_config));
                    this.buttonConfig = JSON.parse(newProduct.div_config);
                } catch (error) {
                    console.error('Error parsing div_config JSON:', error);
                    // Handle the error if parsing fails
                }
            }
            this.showModal('editButtonModal');
        },
        updateButtonConfig() {
            // Perform validations if needed

            // Prepare the div_config field value as a JSON object
            const divConfigValue = JSON.stringify(this.buttonConfig);

            // Update the div_config field in the main product form
            // For example:
            this.newProduct.div_config = divConfigValue;

            // Close the inner modal
            this.$modal.hide('editButtonModal');
        },
        closeModal(modal, reloadData = false) {
            if (reloadData) this.getProducts();
            if (modal === 'newProductModal') {
                this.$v.$reset();
            }
            this.$modal.hide(modal);
        },
        getProducts(page = 1) {
            axios.get("fetch-products?page=" + page).then(response => {
                this.products = response.data;
            });
            this.shouldDisplayPayButton();
        },
        showDd(file) {
            console.log(file);
        },
        showModal(id) {
            this.$modal.show(id);
            // this.$v.$touch();
        },
        showNewProductModal() {
            this.showModal("newProductModal");
        },
        removeThisFile(file) {
            if (this.newProduct.type === "update") {
                let FileName = file.name;
                let self = this;
                console.log(file);
                axios
                    .delete(
                        "products/" + this.newProduct.id + "/images/" + file.id
                    )
                    .then(response => {
                        if (response.data.success) {
                            self.getProducts(self.products.current_page);
                            self.$toastr.s(
                                "Your image has been deleted successfully",
                                "Image deleted"
                            );
                        }
                    });
            }
        },
        dropzoneCompleted(response) {
            this.refreshTablePage();
            this.closeModal("newProductModal");
        },
        beforeClose(modal) {
            if (modal == "newProductModal") {
                this.newProduct = {
                    name: "",
                    description: "",
                    price: "",
                    type: "create",
                    images: [],
                    product_url: "",
                    div_config: ""
                };
            }
        },
        addImages() {
            let self = this;
            console.log(self.newProduct);
            if (self.newProduct.type === "update") {
                console.log(self.newProduct.images);
                if (self.newProduct.images && self.newProduct.images.length) {
                    self.newProduct.images.forEach(image => {
                        console.log(self.$refs.myVueDropzone);
                        var file = {
                            size: image.size,
                            name: image.name,
                            id: image.id,
                            type: image.type
                        };
                        var url = image.img_path;
                        self.$refs.myVueDropzone.manuallyAddFile(file, url);
                    });
                }
            }
        },

        submitProduct() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let self = this;
                self.loading = true;
                if (self.newProduct.type === "update") {
                    let _product = {
                        name: self.newProduct.name,
                        description: self.newProduct.description,
                        price: self.newProduct.price,
                        product_url: self.newProduct.product_url,
                        div_config: self.newProduct.div_config
                    };
                    axios
                        .put("products/" + self.newProduct.id, _product)
                        .then(response => {
                            self.loading = false;
                            if (response.data.success) {
                                if (
                                    self.$refs.myVueDropzone.getQueuedFiles()
                                        .length
                                ) {
                                    self.$refs.myVueDropzone.setOption(
                                        "url",
                                        "products/" +
                                            self.newProduct.id +
                                            "/images"
                                    );
                                    self.$refs.myVueDropzone.processQueue();
                                } else {
                                    this.refreshTablePage();
                                    this.closeModal("newProductModal");
                                }
                            }
                        });
                } else {
                    axios.post("products", this.newProduct).then(response => {
                        self.loading = false;
                        if (response.data.success) {
                            if (
                                self.$refs.myVueDropzone.getQueuedFiles().length
                            ) {
                                self.$refs.myVueDropzone.setOption(
                                    "url",
                                    "products/" + response.data.id + "/images"
                                );
                                self.$refs.myVueDropzone.processQueue();
                            } else {
                                this.refreshTablePage();
                                this.closeModal("newProductModal");
                            }
                        }
                    });
                }
            }
        },
        refreshTablePage() {
            this.getProducts(this.products.current_page);
        },
        editProduct(product) {
            this.newProduct = {
                id: product.id,
                name: product.name,
                description: product.description,
                price: product.price,
                images: product.images,
                type: "update",
                product_url: product.product_url,
                div_config: product.div_config
            };
            this.showNewProductModal();
        },
        togglePublish(product) {
            let self = this;
            self.loading = true;
            let _product = {
                status: product.status == 0 ? 1 : 0,
                name: product.name,
                description: product.description,
                price: product.price,
                product_url: product.product_url,
                div_config: product.div_config
            };
            axios.put("products/" + product.id, _product).then(response => {
                self.loading = false;
                if (response.data.success) {
                    product.status = response.data.data.status;
                    product.status_text = response.data.data.status_text;
                    product.product_url = response.data.data.product_url;
                    product.div_config = response.data.data.div_config;
                }
            });
        },
        deleteProduct(product) {
            let self = this;
            self.loading = true;
            axios.delete("products/" + product.id).then(response => {
                self.loading = false;
                if (response.data.success) {
                    self.getProducts();
                    self.$toastr.s(
                        "Product has been deleted successfully",
                        "Product deleted"
                    );
                }
            });
        },
        async shouldDisplayPayButton() {
            try {
                const response = await axios.get("shouldDisplayPayButton");
                this.displayPayButton = response.data;
                return this.displayPayButton;
            } catch (error) {
                console.error("Error fetching shouldDisplayPayButton:", error);
                return false; // Handle errors gracefully
            }
        }
    },
    mounted() {
        this.app_url = APP_URL;
        this.getProducts();
    }
};
</script>
